$(document).on('click','.cart-note',function(e){
  var $this = $(this);
  if($this.hasClass('active')){
    $this.removeClass('active');
    $this.next('.CartNote').slideUp();
  }else{
    $this.addClass('active');
    $this.next('.CartNote').slideDown();
    $('.CartNote').val('');
  }
});

/*---------   Cart   ---------*/

$("#shoppingcart,.cart-close").on('click', function() {
  $("body").toggleClass("CartOpen");
  return false;
});

/*---------   Quantity Counter   ---------*/

$(function() {
  $('.plus').on('click', function() {
    var $qty = $(this).parents('.CartItem,.cartItem,.addto-cart-part').find("ul.QuantityBox li .QuantityInput");
    var currentVal = parseInt($qty.val(), 10);
    if (!isNaN(currentVal)) {
      $qty.val(currentVal + 1);
    }
  });
  $('.minus').on('click', function() {
    var $qty = $(this).parents('.CartItem,.cartItem,.addto-cart-part').find("ul.QuantityBox li .QuantityInput");
    var currentVal = parseInt($qty.val(), 10);
    if (!isNaN(currentVal) && currentVal > 1) {
      $qty.val(currentVal - 1);
    }
  });

  $('body').click(function(e){

    var popup = $(".cart-side-panel");
    if(!popup.is(e.target) && popup.has(e.target).length === 0){
      if ($("body").hasClass("CartOpen")){
        $("body").removeClass("CartOpen");
      }
    }

  });
  /*
  if($('.sidebar_vendor_li').length > 0){
    $('.sidebar_vendor_li').each(function(e){
      var currentLI = $(this);
      var dataLink = $(this).attr('data-link');
      var linkType = typeof dataLink
      if(linkType != undefined || linkType != 'undefined'){
        $.ajax({
          url:dataLink,
          type:'GET',
          success: function(data){
            var TotalCount = Number($(data).find('#total_products_count').attr('data-products_count'));
            if(TotalCount < 2){
              currentLI.addClass('hide');
            }
          }
        });
      }
    });
  }
  */
});
$(document).on('click','.close-announcement-bar',function(e){
  $(this).parents('#shopify-section-announcement-bar').hide();
});

/* ============================================
   MOBILE menu — match desktop. The mobile hamburger drawer is built from
   the "Header/Sidebar" menu and reads MEN · WOMEN · HATS · DESIGNERS ·
   RAFFLES · SALE · PERFECTLY IMPERFECT. Desktop reads MEN · WOMEN · KIDS ·
   HATS · DESIGNERS · RAFFLES · SALE · PERFECTLY IMPERFECT. This reorders
   the drawer's top level to match and adds a KIDS link (cloned from HATS).
   DESIGNERS sits between HATS and RAFFLES, same as desktop (Cowork edit,
   Aug 2026 — it previously sat last). Only the top level is touched;
   submenus are untouched.
   To revert: delete this block.
   ============================================ */
(function () {
  function fixMobileMenu() {
    var ul = document.querySelector('#shopify-section-header .menu-drawer__navigation > .menu-drawer__menu.list-menu');
    if (!ul) return;
    function label(li) {
      var el = li.querySelector(':scope > a, :scope > details > summary');
      return el ? el.textContent.trim().toUpperCase() : '';
    }
    function byLabel(t) {
      return Array.prototype.slice.call(ul.children).filter(function (li) { return label(li) === t; })[0];
    }
    function byHref(h) {
      return Array.prototype.slice.call(ul.children).filter(function (li) {
        var a = li.querySelector(':scope > a');
        return a && a.getAttribute('href') === h;
      })[0];
    }
    var men = byLabel('MEN'), women = byLabel('WOMEN'), hats = byLabel('HATS'),
        designers = byLabel('DESIGNERS'), raffles = byLabel('RAFFLES'),
        sale = byLabel('SALE'), pi = byLabel('PERFECTLY IMPERFECT');

    var kids = byHref('/collections/kids');
    if (!kids && hats) {
      kids = hats.cloneNode(true);
      var ka = kids.querySelector('a');
      if (ka) { ka.setAttribute('href', '/collections/kids'); ka.textContent = 'Kids'; }
    }
    // append in desired order (appendChild moves existing nodes)
    [men, women, kids, hats, designers, raffles, sale, pi].forEach(function (li) {
      if (li) ul.appendChild(li);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fixMobileMenu);
  else fixMobileMenu();
  window.addEventListener('load', fixMobileMenu);
})();


/* ============================================
   MOBILE — make "Footwear" a dropdown (shoe types) to match desktop.
   Clones the working "Goods" drawer dropdown, relabels it "Footwear",
   fills it with the same shoe-type links desktop uses, and — crucially —
   wires the new summary/close-button into the theme's <header-drawer>
   handlers (onSummaryClick / onCloseButtonClick) so it actually expands
   (the drawer reveals submenus via a JS "menu-opening" class bound only
   to elements present at page load). To revert: delete this block.
   ============================================ */
(function () {
  var SHOE = [['Sneakers','sneakers'],['Running','running'],['Basketball','basketball'],['Boots','boots'],['Sandals & Slides','sandals-slides'],['Loafers','loafers'],['Clogs & Mules','clogs-mules']];
  function setLabel(el, text) {
    var done = false;
    Array.prototype.slice.call(el.childNodes).forEach(function (n) {
      if (!done && n.nodeType === 3 && n.textContent.trim()) { n.textContent = text; done = true; }
    });
    if (!done) el.insertBefore(document.createTextNode(text + ' '), el.firstChild);
  }
  function convert(genderLabel, shoeColl) {
    var drawer = document.querySelector('#shopify-section-header .menu-drawer');
    if (!drawer) return;
    var hd = document.querySelector('header-drawer');
    var top = drawer.querySelector('.menu-drawer__navigation > .menu-drawer__menu');
    if (!top) return;
    var genderLi = Array.prototype.slice.call(top.children).filter(function (li) {
      var s = li.querySelector(':scope > details > summary');
      return s && s.textContent.trim().toUpperCase() === genderLabel;
    })[0];
    if (!genderLi) return;
    var subUl = genderLi.querySelector(':scope > details .menu-drawer__submenu ul.menu-drawer__menu');
    if (!subUl) return;
    var kids = Array.prototype.slice.call(subUl.children);
    var footwearLi = kids.filter(function (li) { var a = li.querySelector(':scope > a'); return a && (a.getAttribute('href') || '') === '/collections/' + shoeColl; })[0];
    var goodsLi = kids.filter(function (li) { var s = li.querySelector(':scope > details > summary'); return s && s.textContent.trim().toUpperCase() === 'GOODS'; })[0];
    if (!footwearLi || !goodsLi) return;
    if (footwearLi.querySelector('details')) return;
    var newLi = goodsLi.cloneNode(true);
    var details = newLi.querySelector(':scope > details');
    if (details) { details.removeAttribute('open'); details.classList.remove('menu-opening'); }
    var summary = newLi.querySelector('summary');
    if (summary) { setLabel(summary, 'Footwear'); summary.setAttribute('aria-expanded', 'false'); }
    var closeBtn = newLi.querySelector('.menu-drawer__close-button');
    if (closeBtn) setLabel(closeBtn, 'Footwear');
    var ul = newLi.querySelector('.menu-drawer__submenu ul.menu-drawer__menu');
    if (!ul) return;
    var tplLi = null;
    Array.prototype.slice.call(ul.children).forEach(function (li) { if (!tplLi && li.querySelector(':scope > a')) tplLi = li; });
    if (!tplLi) return;
    while (ul.firstChild) ul.removeChild(ul.firstChild);
    SHOE.forEach(function (s) {
      var li = tplLi.cloneNode(true);
      var a = li.querySelector('a');
      Array.prototype.slice.call(li.children).forEach(function (c) { if (c !== a) c.remove(); });
      a.setAttribute('href', '/collections/' + shoeColl + '/' + s[1]);
      a.textContent = s[0];
      ul.appendChild(li);
    });
    footwearLi.replaceWith(newLi);
    // wire into the theme's drawer so the new dropdown expands/collapses
    if (hd) {
      if (summary && typeof hd.onSummaryClick === 'function') summary.addEventListener('click', hd.onSummaryClick.bind(hd));
      if (closeBtn && typeof hd.onCloseButtonClick === 'function') closeBtn.addEventListener('click', hd.onCloseButtonClick.bind(hd));
    }
  }
  function run() { convert('MEN', 'mens-shoes'); convert('WOMEN', 'womens-shoes'); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  window.addEventListener('load', run);
})();


/* ============================================
   DESKTOP — move GOODS up beside the departments. cx-redesign builds the
   left rail (#cx-shop) with GOODS pinned to the bottom; this reorders the
   built DOM so GOODS sits right after CLOTHING (or after FOOTWEAR when a
   world has no Clothing, e.g. Kids). Desktop only — the rail is desktop-only;
   the mobile drawer already lists Goods under its department. Runs after
   cx-redesign renders. To revert: delete this block.
   ============================================ */
(function () {
  if (!window.matchMedia('(min-width: 990px)').matches) return;
  function moveGoods() {
    var shop = document.querySelector('#cx-shop');
    if (!shop || shop.getAttribute('data-goods-moved')) return;
    var rows = [].slice.call(shop.querySelectorAll('.cx-goods-row'));
    function rowByLabel(t) {
      return rows.filter(function (r) {
        var a = r.querySelector('a.cx-s');
        return a && a.textContent.trim().toUpperCase() === t;
      })[0];
    }
    var goods = rowByLabel('GOODS');
    if (!goods) return;
    var goodsSub = goods.nextElementSibling;
    var anchor = rowByLabel('CLOTHING') || rowByLabel('FOOTWEAR');
    if (!anchor) return;
    var anchorSub = anchor.nextElementSibling;
    var after = (anchorSub && anchorSub.classList && anchorSub.classList.contains('cx-goods-sub')) ? anchorSub : anchor;
    if (after === goods || after.nextSibling === goods) { shop.setAttribute('data-goods-moved', '1'); return; }
    after.parentNode.insertBefore(goods, after.nextSibling);
    if (goodsSub && goodsSub.classList && goodsSub.classList.contains('cx-goods-sub')) {
      goods.parentNode.insertBefore(goodsSub, goods.nextSibling);
    }
    shop.setAttribute('data-goods-moved', '1');
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', moveGoods);
  else moveGoods();
  window.addEventListener('load', moveGoods);
})();


/* ============================================
   MOBILE — COLLECTION FILTER TOOLBAR (Cowork edit)
   Brings the desktop sidebar's Sort, Brand and department controls to
   mobile collection pages as a compact toolbar shown above the products
   (the toolbar itself is display:none on desktop via custom.css and only
   appears <=749px). Everything is built from elements the theme already
   renders, so the real links/values stay in sync:
     • Sort  — cloned from Dawn's #SortBy options; navigates via ?sort_by=
     • Brand — built from the sidebar brand list (.sidebar_vendor_ul)
     • Dept  — chips built from the department rail (#cx-shop) for the
               current collection. The rail is rendered late by cx-redesign,
               so the chips are added on a few retries once it appears
               (skipped gracefully if it never does). To revert: delete this
               block + the matching ".onm-" CSS block in custom.css.
   ============================================ */
(function () {
  function base() { return '/collections/' + (location.pathname.split('/')[2] || ''); }

  function buildSelects(bar) {
    var row = document.createElement('div');
    row.className = 'onm-row';

    // Sort
    var sb = document.querySelector('#SortBy, select[name="sort_by"]');
    if (sb && sb.options && sb.options.length) {
      var ss = document.createElement('select');
      ss.className = 'onm-select';
      ss.setAttribute('aria-label', 'Sort by');
      Array.prototype.slice.call(sb.options).forEach(function (o) {
        var op = document.createElement('option');
        op.value = o.value;
        op.textContent = o.textContent.trim();
        if (o.selected) op.selected = true;
        ss.appendChild(op);
      });
      ss.addEventListener('change', function () {
        var u = new URL(location.href);
        u.searchParams.set('sort_by', ss.value);
        location.href = u.toString();
      });
      row.appendChild(ss);
    }

    // Brand
    var bul = document.querySelector('.sidebar_vendor_ul');
    if (bul) {
      var links = Array.prototype.slice.call(bul.querySelectorAll('a'));
      if (links.length) {
        var bs = document.createElement('select');
        bs.className = 'onm-select';
        bs.setAttribute('aria-label', 'Shop by brand');
        var ph = document.createElement('option');
        ph.value = '';
        ph.textContent = 'Shop by brand';
        bs.appendChild(ph);
        links.forEach(function (a) {
          var op = document.createElement('option');
          op.value = a.getAttribute('href') || '';
          op.textContent = a.textContent.trim();
          if ((a.getAttribute('href') || '') === location.pathname) op.selected = true;
          bs.appendChild(op);
        });
        bs.addEventListener('change', function () {
          if (!bs.value) return;
          var dest = bs.value;
          var pv = new URLSearchParams(location.search).get('preview_theme_id');
          if (pv) dest += (dest.indexOf('?') === -1 ? '?' : '&') + 'preview_theme_id=' + pv;
          location.href = dest;
        });
        row.appendChild(bs);
      }
    }

    if (row.children.length) bar.appendChild(row);
  }

  function addChips(bar) {
    if (bar.querySelector('.onm-chips')) return true;
    var cx = document.querySelector('#cx-shop');
    if (!cx) return false;
    var b = base();
    var deptLinks = Array.prototype.slice.call(cx.querySelectorAll('a')).filter(function (a) {
      return (a.getAttribute('href') || '').indexOf(b + '/') === 0;
    });
    if (!deptLinks.length) return false;
    var chips = document.createElement('div');
    chips.className = 'onm-chips';
    var allChip = document.createElement('a');
    allChip.className = 'onm-chip' + (location.pathname === b ? ' onm-chip--active' : '');
    allChip.setAttribute('href', b);
    allChip.textContent = 'All';
    chips.appendChild(allChip);
    deptLinks.forEach(function (a) {
      var c = document.createElement('a');
      c.className = 'onm-chip' + (location.pathname === a.getAttribute('href') ? ' onm-chip--active' : '');
      c.setAttribute('href', a.getAttribute('href'));
      c.textContent = a.textContent.trim();
      chips.appendChild(c);
    });
    bar.insertBefore(chips, bar.firstChild);
    return true;
  }

  function build() {
    var wrap = document.querySelector('.collection_filter_grid .sidebar_vendor_wrap');
    if (!wrap) return;
    var bar = document.getElementById('onm-toolbar');
    if (!bar) {
      bar = document.createElement('div');
      bar.id = 'onm-toolbar';
      buildSelects(bar);
      if (bar.children.length) wrap.insertBefore(bar, wrap.firstChild);
    }
    if (bar) addChips(bar);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', build);
  else build();
  window.addEventListener('load', build);
  document.addEventListener('shopify:section:load', build);
  [400, 900, 1600, 2600, 4000].forEach(function (t) { window.setTimeout(build, t); });
})();
